import { Component, OnInit } from '@angular/core';
import { TppCommonService } from '@nspk/tpp-front-commons';
import { Router } from '@angular/router';

@Component({
    standalone: false,
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {

    counter: number;
    redirectUrl: string;
    loading: boolean;

    constructor(
        private router: Router,
        private tppCommonService: TppCommonService
    ) {
    }

    ngOnInit(): void {
        this.redirectUrl = 'https://mironline.ru/mirpay';
        if (this.tppCommonService.getCookie('redirectToMirOnline')) {
            this.tppCommonService.deleteCookie('redirectToMirOnline');

            this.counter = 5;

            const interval = setInterval(() => {
                if (this.counter > 0) {
                    this.counter = --this.counter;
                } else {
                    clearInterval(interval);
                    this.loading = true;
                    window.location.href = this.redirectUrl;
                }
            }, 1000);
        } else {
            this.router.navigate(['/']);
        }

    }

}
